import { Store } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';
import { submitCustomizeModal } from 'ChartApp/ts/apps/scatter-plot/state/plot-options/plot-options.actions';
import { addScatterPlotSecurities, removeScatterPlotSecurity, } from 'ChartApp/ts/apps/scatter-plot/state/securities/securities.actions';
import { getChartOptions, getLabelPlacements, getPlotOptions, } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.selectors';
import { SCATTER_PLOT_BOOLEAN_OPTIONS_DEFAULT, SCATTER_PLOT_LABEL_PLACEMENT_OPTIONS_DEFAULT, SCATTER_PLOT_PLOT_OPTIONS_DEFAULT, SCATTER_PLOT_SHAPE_OPTIONS_DEFAULT, SCATTER_PLOT_SIZE_OPTIONS_DEFAULT, } from 'ChartApp/ts/features/scatter-plot-page-shared/components/scatter-plot-customize-modal/scatter-plot-plot-options.constants';
import { ScatterPlotLabelPlacement, ScatterPlotPlotOptionValue, ScatterPlotSeriesType, } from 'ChartApp/ts/enums/scatter-plot-common.enum';
import { ColorPickerComponent } from 'NewAngular/features/components/inputs/color-picker/color-picker.component';
import equal from 'NewAngular/utils/equal/deep-equal';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/components/inputs/color-picker/color-picker.component";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
const _c0 = ["colorPickerComponent"];
const _c1 = () => ({ button: "btn btn-block btn-secondary dropdown-toggle", dropdownContainer: "width-112 mt-1", dropdownItem: "text-default" });
const _c2 = a0 => ({ "color": a0 });
const _c3 = a0 => ({ "current": a0 });
function ScatterPlotCustomizeModalComponent_div_41_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "label", 22)(2, "input", 23);
    i0.ɵɵlistener("change", function ScatterPlotCustomizeModalComponent_div_41_Template_input_change_2_listener() { const config_r3 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setPlotOptionsSelected(config_r3.value, !ctx_r3.plotOptionsSelected[config_r3.value])); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 24)(4, "span", 28);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const config_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r3.plotOptionsSelected[config_r3.value]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", config_r3.label);
} }
function ScatterPlotCustomizeModalComponent_div_42_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10);
    i0.ɵɵtext(2, "Placement");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ycn-single-select-dropdown", 11);
    i0.ɵɵlistener("changeHandler", function ScatterPlotCustomizeModalComponent_div_42_Template_ycn_single_select_dropdown_changeHandler_3_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setPlotOptionsSelected("labelPlacement", $event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("config", ctx_r3.labelPlacementOptionsConfig)("customCssClasses", i0.ɵɵpureFunction0(3, _c1))("selectedValue", ctx_r3.selectedLabelPlacement);
} }
function ScatterPlotCustomizeModalComponent_div_43_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 32);
} if (rf & 2) {
    const placement_r6 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c3, ctx_r3.selectedLabelPlacement === placement_r6.value));
} }
function ScatterPlotCustomizeModalComponent_div_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10);
    i0.ɵɵtext(2, "Label Placement Example");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 29);
    i0.ɵɵtemplate(4, ScatterPlotCustomizeModalComponent_div_43_div_4_Template, 1, 3, "div", 30);
    i0.ɵɵelementStart(5, "div", 31);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(6, "svg", 15);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r3.labelPlacementOptionsConfig.list.slice(1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(3, _c2, ctx_r3.plotOptionsSelected.color));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-shape-" + ctx_r3.selectedShapeValue);
} }
export class ScatterPlotCustomizeModalComponent {
    constructor(store) {
        this.store = store;
        // Modal State
        this.isOpen = false;
        this.uniquePointId = '';
        this.labelPlacements = {};
        this.plotOptionsSelected = SCATTER_PLOT_PLOT_OPTIONS_DEFAULT;
        this.parentSecurityList = '';
        this.securities = [];
        // Plot Options Configs
        this.booleanPlotOptionsConfig = SCATTER_PLOT_BOOLEAN_OPTIONS_DEFAULT;
        this.labelPlacementOptionsConfig = cloneDeep(SCATTER_PLOT_LABEL_PLACEMENT_OPTIONS_DEFAULT);
        this.selectedLabelPlacement = ScatterPlotLabelPlacement.default;
        this.shapeOptionsConfig = cloneDeep(SCATTER_PLOT_SHAPE_OPTIONS_DEFAULT);
        this.selectedShapeValue = SCATTER_PLOT_PLOT_OPTIONS_DEFAULT.shape;
        this.sizeOptionsConfig = cloneDeep(SCATTER_PLOT_SIZE_OPTIONS_DEFAULT);
        this.selectedSizeValue = SCATTER_PLOT_PLOT_OPTIONS_DEFAULT.size;
        this.useCustomColors = false;
        // Plot Options Config
        this.plotOptionsConfig = [
            { label: 'Show X/Y Data', value: ScatterPlotPlotOptionValue.displayXYData },
            { label: 'Show Ticker', value: ScatterPlotPlotOptionValue.displayTicker },
            { label: 'Show Name', value: ScatterPlotPlotOptionValue.displayName },
            { label: 'Show Dates', value: ScatterPlotPlotOptionValue.displayDates },
            { label: 'Show Currency Code', value: ScatterPlotPlotOptionValue.displayCurrencyCode },
        ];
        // List position of the item being customized. Used for retrieving default values from default constants.
        this.index = 0;
        this.mapStateToComponent = (state) => {
            this.chartOptions = getChartOptions(state);
            this.labelPlacements = getLabelPlacements(state);
            this.plotOptions = getPlotOptions(state);
            this.securities = state.scatterPlot.securities;
            this.useCustomColors = state.scatterPlot.useCustomColors;
        };
        this.store.select('reducers').subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    // Methods that open / keep the modal open
    /**
     * Opens the modal and displays the plot options for the security selected to be customized.
     * @param plotOptionsId - The id for a specific security's plot options. <security type>__<security id>
     *     e.g. security__AAPL
     * @param securityName - The name of the security being customized e.g. Apple
     * @param index - The position of the security in the list of securities.
     * @param parentSecurityListPlotOptionsId (optional) - For security overrides, this parameter points to its parent
     *    security list's plotOptionsId (e.g. security_list__nasdaq_100)
     * @param newOverride (optional) - For security overrides, the unique identifier for the point.
     * @param uniquePointId (optional) - For security overrides, the unique identifier for the point.
     */
    openModal(plotOptionsId, securityName, index, parentSecurityListPlotOptionsId, newOverride, uniquePointId) {
        if (uniquePointId) {
            this.uniquePointId = uniquePointId;
        }
        if (this.plotOptions) {
            // Update selected plot options
            this.plotOptionsSelected = this.plotOptions[plotOptionsId];
            // If we have a parent security list, then that means we are trying to customize an individual security
            // within a security list (by clicking on the point directly on the chart).
            if (parentSecurityListPlotOptionsId) {
                [, this.parentSecurityList] = parentSecurityListPlotOptionsId.split('__');
                if (newOverride) {
                    this.plotOptionsSelected = { ...this.plotOptions[parentSecurityListPlotOptionsId] };
                    // For override securities, don't bother with default colors. It gets very complicated from both a
                    // product and engineering standpoint. Instead just hard code the color to the parent's color right now.
                    if (!this.plotOptionsSelected[ScatterPlotPlotOptionValue.color]) {
                        this.plotOptionsSelected[ScatterPlotPlotOptionValue.color] =
                            this.colorPickerComponent.getDefaultColorForIndex(index);
                    }
                }
            }
            this.index = index;
            // Update dropdown config objects to display the default or selected value
            // Checkbox options
            this.booleanPlotOptionsConfig = this.booleanPlotOptionsConfig.map((booleanOption) => {
                const newBooleanOption = { ...booleanOption };
                if (this.plotOptionsSelected && booleanOption.value in this.plotOptionsSelected) {
                    newBooleanOption.checked = this.plotOptionsSelected[booleanOption.value];
                }
                return newBooleanOption;
            });
            // Dropdown options
            this.selectedShapeValue = this.plotOptionsSelected.shape;
            this.selectedSizeValue = this.plotOptionsSelected.size;
            this.selectedLabelPlacement = uniquePointId
                ? this.labelPlacements[uniquePointId] || ScatterPlotLabelPlacement.default
                : ScatterPlotLabelPlacement.default;
            this.colorPickerComponent.setColor(this.plotOptionsSelected.color, this.index);
        }
        this.isOpen = true;
        this.plotOptionsId = plotOptionsId;
        this.securityName = securityName;
    }
    /**
     * Set the plot options to default values for the selected security.
     */
    resetModal() {
        // Reset selected plot options
        this.plotOptionsSelected = cloneDeep(SCATTER_PLOT_PLOT_OPTIONS_DEFAULT);
        if (this.parentSecurityList) {
            this.plotOptionsSelected = cloneDeep(this.plotOptions[`${ScatterPlotSeriesType.securityList}__${this.parentSecurityList}`]);
        }
        // Reset dropdown config options so the dropdowns show the correct default value
        this.selectedShapeValue = this.plotOptionsSelected.shape;
        this.selectedSizeValue = this.plotOptionsSelected.size;
        this.selectedLabelPlacement = ScatterPlotLabelPlacement.default;
        // Reset checkboxes
        this.booleanPlotOptionsConfig = SCATTER_PLOT_BOOLEAN_OPTIONS_DEFAULT;
        // Reset color picker
        this.colorPickerComponent.setColor(this.plotOptionsSelected.color, this.index);
    }
    // Methods that close the modal
    /**
     * Close the modal. Note: This does not save changes made in the modal.
     */
    closeModal() {
        this.plotOptionsSelected = SCATTER_PLOT_PLOT_OPTIONS_DEFAULT;
        this.isOpen = false;
        this.parentSecurityList = '';
        this.uniquePointId = '';
    }
    /**
     * Close the modal and save new plot options to NgRx store.
     */
    submitModal() {
        // An empty string indicates the default color should be used.
        // This is done to avoid adding an extra attribute i.e. useDefaultColor to plotOptions.
        // Since plotOptions are part of the url app state, any additional attributes in plot options would become
        // additional url parameters. The scatter plot url app state is already very large.
        // We want to avoid making it longer or more complex.
        if (this.colorPickerComponent.useDefaultColor) {
            this.plotOptionsSelected.color = '';
        }
        const newPlotOptions = { ...this.plotOptions };
        newPlotOptions[this.plotOptionsId] = this.plotOptionsSelected;
        this.store.dispatch(submitCustomizeModal({
            plotOptions: newPlotOptions,
            labelPlacement: this.selectedLabelPlacement,
            uniquePointId: this.uniquePointId,
        }));
        this.addAndRemoveSecurityOverrides();
        this.closeModal();
    }
    equalBesidesColor(plotOptions, parentOptions) {
        // If the parent has a color, verify full match
        // Otherwise, verify
        //  1. every other key matches
        //  2. default color matches child color
        const parentColor = parentOptions.color;
        const parentOptionsWithColor = { ...parentOptions };
        if (!parentColor) {
            parentOptionsWithColor[ScatterPlotPlotOptionValue.color] = '';
        }
        return equal(plotOptions, parentOptionsWithColor);
    }
    /**
     * If necessary, adds and removes security overrides.
     *  - First, we identify if the security represented by plotOptionsId is a security override or not
     *  - If so,
     *      - If the plot options are the default, then the modal has been reset and we want to remove the override
     *      - Else, add the security along with the parent_security_list
     */
    addAndRemoveSecurityOverrides() {
        const [securityType, securityId] = this.plotOptionsId.split('__');
        if (this.parentSecurityList) {
            if (this.equalBesidesColor(
            // equal(
            this.plotOptionsSelected, 
            // eslint-disable-next-line camelcase
            this.plotOptions[`${ScatterPlotSeriesType.securityList}__${this.parentSecurityList}`])) {
                // Modal has been reset. Remove the security override
                this.store.dispatch(removeScatterPlotSecurity({
                    scatterPlotSecurity: {
                        id: securityId,
                        type: securityType,
                    },
                }));
            }
            else {
                this.store.dispatch(addScatterPlotSecurities({
                    scatterPlotSecurities: [
                        {
                            id: securityId,
                            include: true,
                            type: ScatterPlotSeriesType.security,
                            parent_security_list: this.parentSecurityList,
                        },
                    ],
                    scatterPlotChartOptions: this.chartOptions,
                }));
            }
        }
    }
    // Update state
    /**
     * Update the value of the modified plot option.
     * @param name - The name of the plot option to update
     * @param value - The new value of the updated plot option
     */
    setPlotOptionsSelected(name, value) {
        this.plotOptionsSelected = {
            ...this.plotOptionsSelected,
            [name]: value,
        };
        // Update selected values to display in the dropdowns
        if (name === 'shape')
            this.selectedShapeValue = value;
        if (name === 'size')
            this.selectedSizeValue = value;
        if (name === 'labelPlacement')
            this.selectedLabelPlacement = value;
    }
}
ScatterPlotCustomizeModalComponent.ɵfac = function ScatterPlotCustomizeModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ScatterPlotCustomizeModalComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
ScatterPlotCustomizeModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ScatterPlotCustomizeModalComponent, selectors: [["ycn-scatter-plot-customize-modal"]], viewQuery: function ScatterPlotCustomizeModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.colorPickerComponent = _t.first);
    } }, standalone: false, decls: 53, vars: 29, consts: [["colorPickerComponent", ""], [3, "closeModalHandler", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [1, "modal-section-title"], [1, "row", "mb-3"], [1, "col-8"], [1, "row"], [1, "col-4"], [1, "form-label", "form-label-thin"], [3, "changeHandler", "config", "customCssClasses", "selectedValue"], ["dropdownClass", "mt-1", 3, "setColorHandler", "useCustomColors"], [1, "shape-size-select", "mt-1"], [1, "shape-select-choice", "size-sm", 2, "cursor", "default", 3, "ngStyle"], ["ycnIcon", "", 3, "name"], [1, "shape-select-choice", "size-md", 2, "cursor", "default", 3, "ngStyle"], [1, "shape-select-choice", "size-lg", 2, "cursor", "default", 3, "ngStyle"], [1, "row", "no-gutters", "mt-1"], ["class", "col-6 mb-1", 4, "ngFor", "ngForOf"], ["class", "col-4", 4, "ngIf"], [1, "mb-1"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description"], [3, "cancelHandler", "submitHandler", "cancelButtonText", "submitButtonText"], [1, "col-6", "mb-1"], [1, "custom-control-description", 3, "textContent"], [1, "placement-select", "mt-1"], ["class", "placement-choice", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "shape-select-choice", "size-md", "text-1", 3, "ngStyle"], [1, "placement-choice", 3, "ngClass"]], template: function ScatterPlotCustomizeModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function ScatterPlotCustomizeModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function ScatterPlotCustomizeModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "div", 5);
        i0.ɵɵtext(5, "Indicator");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 6)(7, "div", 7)(8, "div", 8)(9, "div", 9)(10, "div", 10);
        i0.ɵɵtext(11, "Shape");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "ycn-single-select-dropdown", 11);
        i0.ɵɵlistener("changeHandler", function ScatterPlotCustomizeModalComponent_Template_ycn_single_select_dropdown_changeHandler_12_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setPlotOptionsSelected("shape", $event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "div", 9)(14, "div", 10);
        i0.ɵɵtext(15, "Size");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "ycn-single-select-dropdown", 11);
        i0.ɵɵlistener("changeHandler", function ScatterPlotCustomizeModalComponent_Template_ycn_single_select_dropdown_changeHandler_16_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setPlotOptionsSelected("size", $event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(17, "div", 9)(18, "div", 10);
        i0.ɵɵtext(19, "Color");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "ycn-color-picker", 12, 0);
        i0.ɵɵlistener("setColorHandler", function ScatterPlotCustomizeModalComponent_Template_ycn_color_picker_setColorHandler_20_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setPlotOptionsSelected("color", $event)); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(22, "div", 9)(23, "div", 10);
        i0.ɵɵtext(24, "Indicator Example");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "div", 13)(26, "div", 14);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(27, "svg", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(28, "div", 16);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(29, "svg", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(30, "div", 17);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(31, "svg", 15);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(32, "div", 5);
        i0.ɵɵtext(33, "Indicator Label");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "div", 8)(35, "div", 7)(36, "div", 8)(37, "div", 7)(38, "div", 10);
        i0.ɵɵtext(39, "Information");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(40, "div", 18);
        i0.ɵɵtemplate(41, ScatterPlotCustomizeModalComponent_div_41_Template, 5, 2, "div", 19);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(42, ScatterPlotCustomizeModalComponent_div_42_Template, 4, 4, "div", 20);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(43, ScatterPlotCustomizeModalComponent_div_43_Template, 7, 5, "div", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(44, "div", 5);
        i0.ɵɵtext(45, "Legend");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(46, "div", 21)(47, "label", 22)(48, "input", 23);
        i0.ɵɵlistener("change", function ScatterPlotCustomizeModalComponent_Template_input_change_48_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setPlotOptionsSelected("include_in_legend", !ctx.plotOptionsSelected["include_in_legend"])); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(49, "span", 24);
        i0.ɵɵelementStart(50, "span", 25);
        i0.ɵɵtext(51, "Include Name in Legend");
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(52, "ycn-simple-modal-footer", 26);
        i0.ɵɵlistener("cancelHandler", function ScatterPlotCustomizeModalComponent_Template_ycn_simple_modal_footer_cancelHandler_52_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.resetModal()); })("submitHandler", function ScatterPlotCustomizeModalComponent_Template_ycn_simple_modal_footer_submitHandler_52_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.submitModal()); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.securityName);
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("config", ctx.shapeOptionsConfig)("customCssClasses", i0.ɵɵpureFunction0(21, _c1))("selectedValue", ctx.selectedShapeValue);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("config", ctx.sizeOptionsConfig)("customCssClasses", i0.ɵɵpureFunction0(22, _c1))("selectedValue", ctx.selectedSizeValue);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("useCustomColors", ctx.useCustomColors);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(23, _c2, ctx.selectedSizeValue === "small" ? ctx.plotOptionsSelected.color : ""));
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-shape-" + ctx.selectedShapeValue);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(25, _c2, ctx.selectedSizeValue === "medium" ? ctx.plotOptionsSelected.color : ""));
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-shape-" + ctx.selectedShapeValue);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(27, _c2, ctx.selectedSizeValue === "large" ? ctx.plotOptionsSelected.color : ""));
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-shape-" + ctx.selectedShapeValue);
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngForOf", ctx.plotOptionsConfig);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.uniquePointId);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.uniquePointId);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("checked", ctx.plotOptionsSelected["include_in_legend"]);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("cancelButtonText", "Reset")("submitButtonText", "Apply");
    } }, dependencies: [i2.ColorPickerComponent, i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgStyle, i4.IconDirective, i5.ModalBaseComponent, i6.SimpleModalFooterComponent, i7.SimpleModalHeaderComponent, i8.SingleSelectDropdownComponent], encapsulation: 2 });
